/**
 * Single source of truth for Vuetify breakpoint thresholds.
 *
 * Used by:
 *  - nuxt.config.ts → vuetifyOptions.display.thresholds  (JS runtime)
 *  - nuxt.config.ts → generateBreakpointsScss()          (writes _breakpoints.scss)
 *  - app/assets/scss/components.scss                      (hardcoded — validated at build time)
 *  - app code that has to state a breakpoint outside CSS (e.g. the media
 *    queries in app/utils/format/imageSizes.ts)
 *
 * components.scss MUST have hardcoded values (no @use) because it's the
 * vuetify-nuxt-module configFile. validateComponentsBreakpoints() checks
 * that its values match this file at build time.
 *
 * The SCSS partial _breakpoints.scss is auto-generated — do NOT edit manually.
 *
 * Values only: this file is imported by app code, so it must stay free of Node
 * imports. The build-time helpers that read and write the SCSS live in
 * breakpoints-scss.ts.
 */
export const breakpoints = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1264,
  xl: 1920,
  xxl: 2560,
} as const

// A media query for "this breakpoint and up", for code that states one outside CSS
// (image sizes, lazy hydration).
export const minWidthQuery = (breakpoint: keyof typeof breakpoints) => `(min-width: ${breakpoints[breakpoint]}px)`
